export default "__VITE_ASSET__Ctw4U8PP__"